(ns frontend.ui.component.lp-portal.report.body.invest-europe.fund.web
  (:require
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.section.view :as section]
   [frontend.ui.component.lp-portal.report.component.overview-figures.view :as ov-figures]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]))

(defn- overview-section
  [overview props]
  (let [{:keys [overview-figures]}
        overview]
    [section/section
     "Overview" ;; NOTE hardcoded -> do we want to localize these ??
     (str "overview-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [ov-figures/overview-figures-card overview-figures props]]]))

(defn- fund-information-section
  [fund-information props]
  (let [{:keys [fund-value-bridge historical-fund-performance value-progression carried-interest-and-expenses
                fund-performance-status-1 fund-performance-status-2]}
        fund-information]
    [section/section
     "Fund information" ;; NOTE hardcoded -> do we want to localize these ??
     (str "fund-information-"
          (some->> props
                   :report
                   :db/id))
     [:div
      ; TODO - where to get the currency ??
      [chart-card/row-view "Fund value bridge (???)" fund-value-bridge props]
      [vertical-table/table "GP fees, carried interest and fund operating expenses"
       carried-interest-and-expenses props]
      [horizontal-table/table "Fund performance status 1" fund-performance-status-1 props]
      [vertical-table/table "Fund performance status 2" fund-performance-status-2 props]]]))

(defn- fund-financials-section
  [fund-financials props]
  (let [{:keys [balance-sheet]} fund-financials]
    [section/section "Fund financials"
     (str "fund-financials-"
          (some->> props
                   :report
                   :db/id))
     [:div
      #_[horizontal-table/table "Balance sheet" balance-sheet props]]]))

(defn- portfolio-information-section
  [portfolio-information props]
  (let [{:keys [portfolio-summary]} portfolio-information]
    [section/section "Portfolio information"
     (str "portfolio-information-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [horizontal-table/table "Portfolio summary" portfolio-summary props]]]))

(defn- investor-information-section
  [investor-information props]
  (let [{:keys [capital-account]} investor-information]
    [section/section "Investor information"
     (str "investor-information-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [horizontal-table/table "Capital account" capital-account props]]]))

(defn report-view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [overview fund-information fund-financials portfolio-information investor-information]} fund-ui-data]
    [:div
     [:div {:id :overview}
      [:div
       [overview-section overview props]]]
     [:div {:id :fund-information}
      [:div
       [fund-information-section fund-information props]]]
     [:div {:id :fund-financials}
      [:div
       [fund-financials-section fund-financials props]]]
     [:div {:id :portfolio-information}
      [:div
       [portfolio-information-section portfolio-information props]]]
     [:div {:id :investor-information}
      [:div
       [investor-information-section investor-information props]]]
    ]))
